import { useCallback, useEffect, useState } from 'react';
import { pluginSettingsVar } from '../../../apollo/store';
import {
    AutoConfig,
    ProductConfiguration,
    ProductConfigurationDocument,
    ProductConfigurationQuery,
} from 'gql/__generated/vp-apollo';
import { useVerifyProductId } from 'hooks/useVerifyProductId';
import { client } from '../../../apollo/client';
import { shopSessionStorageService as sessionStorageService } from '@cobra/fe-lib/services';
import { CheckoutType } from '@cobra/interfaces-enums-mocks/enums';

export const useCheckAutoConfig = (autoConfig: AutoConfig) => {
    const { linkToProductConfig, linkToCheckout } = pluginSettingsVar();
    const { verifyProductId, verifiedProductId, loading, error } = useVerifyProductId();
    const [exitPath, setExitPath] = useState<string | undefined>();

    const checkAutoConfig = useCallback(() => {
        verifyProductId(autoConfig.product as number | undefined);
    }, [autoConfig, verifyProductId]);

    const storeProductConfiguration = useCallback((prodConf: ProductConfiguration) => {
        client.writeQuery<ProductConfigurationQuery>({
            query: ProductConfigurationDocument,
            data: { productConfiguration: { __typename: 'ProductConfiguration', ...prodConf } },
        });
    }, []);

    useEffect(() => {
        if (verifiedProductId) {
            storeProductConfiguration({
                product: verifiedProductId,
                options: (autoConfig.options as number[]) || [],
                companionProducts: (autoConfig.companionProducts as number[]) || [],
            });

            sessionStorageService.storeCheckoutType(CheckoutType.NEW);

            if (
                (autoConfig.options && autoConfig.options.length > 0) ||
                (autoConfig.companionProducts && autoConfig.companionProducts.length > 0)
            ) {
                setExitPath(linkToCheckout);
            } else {
                setExitPath(linkToProductConfig);
            }
        }
    }, [verifiedProductId, linkToProductConfig, linkToCheckout, storeProductConfiguration, autoConfig]);

    return {
        checkAutoConfig,
        exitPath,
        error,
        loading,
    };
};
